import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "confirmation"]

    show(event) {
        event.preventDefault()
        this.contentTarget.classList.add("hidden")
        this.confirmationTarget.classList.remove("hidden")
    }

    cancel(event) {
        event.preventDefault()
        this.confirmationTarget.classList.add("hidden")
        this.contentTarget.classList.remove("hidden")
    }
}
